/**
 * Por qué el paso Envío del wizard no deja lanzar la campaña, o null si puede.
 *
 * Es una función pura para poder testear la regla sin montar la página entera del wizard. El
 * backend es la autoridad (send() rechaza igual con EJEMPLO / YA_PROGRAMADA); esto sólo evita
 * ofrecer un botón verde que va a fallar, y dice el motivo en el propio botón.
 */
export const MOTIVO_EJEMPLO = "Son datos de ejemplo: no se envían";
/**
 * Sin el nombre del comercio los mensajes salían firmados «Tu marca» (QA del 08/10). El backend ya no envía sin él
 * (SIN_MARCA); acá el botón lo dice, y el paso muestra dónde ponerlo (`FirmaComercio`).
 */
export const MOTIVO_SIN_MARCA = "Poné el nombre de tu comercio para enviar";

export function bloqueoEnvio(
  campaign: { estado?: string; esEjemplo?: boolean } | null | undefined,
  opts: { sinGrupos?: boolean; archivosDeEjemplo?: boolean; sinMarca?: boolean } = {},
): string | null {
  // Primero el ejemplo: sus clientes son personas ajenas a la marca y no hay nada que el
  // operador pueda cambiar en el wizard para mandarles. `archivosDeEjemplo` cubre un borrador
  // guardado antes de que la campaña trajera la marca `esEjemplo`.
  if (campaign?.esEjemplo || opts.archivosDeEjemplo) return MOTIVO_EJEMPLO;
  // ya agendada: mandar ahora tiene que ser una decisión explícita (cancelar la programación)
  if (campaign?.estado === "programada") return "Ya está programada · cancelá la programación para enviar ahora";
  if (opts.sinMarca) return MOTIVO_SIN_MARCA;
  if (opts.sinGrupos) return "Elegí al menos un grupo para enviar";
  return null;
}
